import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  DocumentIcon, 
  MoneyIcon, 
  WalletIcon, 
  ChartIcon, 
  TargetIcon,
  TrendingUpIcon,
  UserIcon,
  AnalyticsIcon,
  ShoppingCartIcon,
  IncomeIcon,
  HistoryIcon,
  CalendarIcon
} from '../UI/Icons';
import { useIsMobile, useIsPWA } from '../../utils';
import './Navigation.css';

interface NavItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  mobileIcon?: React.ReactNode;
  path: string;
}

const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const isPWA = useIsPWA();

  const handleProfileClick = () => {
    navigate('/dashboard/profile');
  };

  const allNavItems: NavItem[] = [
    { 
      id: 'expenses', 
      label: 'Витрати', 
      icon: <DocumentIcon size={20} />, 
      mobileIcon: <ShoppingCartIcon size={24} />,
      path: '/dashboard/expenses' 
    },
    { 
      id: 'income', 
      label: 'Доходи', 
      icon: <MoneyIcon size={20} />, 
      mobileIcon: <IncomeIcon size={24} />,
      path: '/dashboard/income' 
    },
    { 
      id: 'accounts', 
      label: 'Рахунки', 
      icon: <WalletIcon size={20} />, 
      path: '/dashboard/accounts' 
    },
    { 
      id: 'history', 
      label: 'Історія', 
      icon: <ChartIcon size={20} />, 
      mobileIcon: <HistoryIcon size={24} />,
      path: '/dashboard/history' 
    },
    { 
      id: 'budgets', 
      label: 'Планування', 
      icon: <TargetIcon size={20} />, 
      mobileIcon: <CalendarIcon size={24} />,
      path: '/dashboard/budgets' 
    },
    { 
      id: 'recurring', 
      label: 'Шаблони', 
      icon: <TrendingUpIcon size={20} />, 
      path: '/dashboard/recurring' 
    },
    { 
      id: 'statistics', 
      label: 'Статистика', 
      icon: <AnalyticsIcon size={20} />, 
      path: '/dashboard/statistics' 
    },
    { 
      id: 'monthly-plan', 
      label: 'План місяця', 
      icon: <CalendarIcon size={20} />, 
      path: '/dashboard/monthly-plan' 
    }
  ];

  // Для мобільної версії прибираємо кнопки "Рахунки", "Статистика", "Шаблони" та "План місяця" (доступні з профілю)
  const navItems = isMobile
    ? allNavItems.filter(item => !['accounts', 'statistics', 'recurring', 'monthly-plan'].includes(item.id))
    : allNavItems;

  return (
    <>
      <nav className="nav-container">
        <div className="nav-content">
          <div className="nav-items">
            {navItems.map(item => (
              <NavLink
                key={item.id}
                to={item.path}
                className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              >
                {item.label}
              </NavLink>
            ))}
          </div>
          {!isMobile && (
            <button
              className="nav-profile-button"
              onClick={handleProfileClick}
              title="Профіль користувача"
            >
              <UserIcon size={20} />
            </button>
          )}
        </div>
      </nav>

      <nav className={`mobile-nav ${isPWA ? 'mobile-nav-pwa' : ''}`}>
        <div className="mobile-nav-content">
          {navItems.map(item => (
            <NavLink
              key={item.id}
              to={item.path}
              className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
            >
              <span className="mobile-nav-icon">
                {item.mobileIcon || item.icon}
              </span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </>
  );
};

export default Navigation;
